import type { Vector3 } from 'three';

import type { LightingManager } from '../lighting-manager.class';
import type { HighlightSpotlightConfig } from '../types';

export interface EnableHighlightParams {
	position: Vector3;
	target: Vector3;
	config?: HighlightSpotlightConfig;
}

/**
 * Enable highlight mode (dims directional light, shows spotlight)
 */
export const enableHighlightCfn = (self: LightingManager, params: EnableHighlightParams): void => {
	const { position, target, config } = params;
	const directionalLight = self.internalDirectionalLight;
	const highlightSpotLight = self.internalHighlightSpotLight;

	// Store and dim directional light
	if (directionalLight) {
		self.internalDirectionalLightOriginalIntensity = directionalLight.intensity;
		self.internalDirectionalLightOriginalVisible = directionalLight.visible;
		directionalLight.intensity = 0;
		directionalLight.visible = false;
	}

	// Configure and show spotlight
	if (highlightSpotLight) {
		highlightSpotLight.position.copy(position);
		highlightSpotLight.target.position.copy(target);

		if (config) {
			if (config.color !== undefined) highlightSpotLight.color.setHex(config.color);
			if (config.intensity !== undefined) highlightSpotLight.intensity = config.intensity;
			if (config.angle !== undefined) highlightSpotLight.angle = config.angle;
			if (config.penumbra !== undefined) highlightSpotLight.penumbra = config.penumbra;
			if (config.decay !== undefined) highlightSpotLight.decay = config.decay;
			if (config.distance !== undefined) highlightSpotLight.distance = config.distance;
		} else {
			highlightSpotLight.intensity = 1000;
		}

		highlightSpotLight.visible = true;
	}
};
